module.exports = __webpack_public_path__ + "img/image.d8d3ba08.svg";